export type OrganicTabId =
  | "facebook-content"
  | "instagram-content"
  | "facebook-followers"
  | "instagram-followers"
  | "tiktok-content-followers"
  | "snapchat-content-followers";

export const ORGANIC_TAB_ITEMS: OrganicTabId[] = [
  "facebook-content",
  "instagram-content",
  "facebook-followers",
  "instagram-followers",
  "tiktok-content-followers",
  "snapchat-content-followers",
];

export const ORGANIC_TAB_I18N_KEYS: Record<OrganicTabId, string> = {
  "facebook-content": "organicMedia.tabs.facebookContent",
  "instagram-content": "organicMedia.tabs.instagramContent",
  "facebook-followers": "organicMedia.tabs.facebookFollowers",
  "instagram-followers": "organicMedia.tabs.instagramFollowers",
  "tiktok-content-followers": "organicMedia.tabs.tiktokContentFollowers",
  "snapchat-content-followers": "organicMedia.tabs.snapchatContentFollowers",
};
